'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _footer = require('./footer.styles');
var _wavfichacertaFichacertaSharedStyles = require('@bit/wavfichacerta.fichacerta.shared-styles.rows');
var _MaxOfResultsSelect = require('./MaxOfResultsSelect');
var _MaxOfResultsSelect2 = _interopRequireDefault(_MaxOfResultsSelect);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var MaxPerPage = function MaxPerPage(_ref) {
  var onSelect = _ref.onSelect,
    max = _ref.max;
  return _react2.default.createElement(_footer.MaxPerPageCol, null, _react2.default.createElement(_wavfichacertaFichacertaSharedStyles.StyledRow, {
    justify: 'flex-start'
  }, _react2.default.createElement(_footer.Typography, null, 'Resultados por p\xE1gina:'), _react2.default.createElement(_MaxOfResultsSelect2.default, {
    onChange: onSelect,
    value: max
  })));
};
exports.default = MaxPerPage;